import * as errors from "../errors.js";
import { state } from "../state.js";
/*
    The numeric function SIN is a mathematical function which evaluates to the sine for a given angle, a number regarded as being in radians.
    If the term given in the parentheses is non-numerical, the BASIC error ?TYPE MISMATCH ERROR occurs. Being a floating point argument, the 
    term must be in the range of ±2.93873588·10−38 to ±1.70141183·1038. Exceeding these limits yields the BASIC error ?OVERFLOW ERROR. 
    Omitting the numeric argument or too many arguments results in a ?SYNTAX ERROR. 
*/
export const sin = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    // Check for overflow.
    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Calculate the sine.
    const result = Math.sin(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};